// Loading.tsx
import type { FC } from 'react';
import Container from 'react-bootstrap/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { t } from 'i18next';

export const LoadingTemplate = () => {
  return (
    <Container
      fluid
      className="min-vh-100 d-flex align-items-center justify-content-center"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <FontAwesomeIcon icon={faSpinner} spin className="text-primary" size="10x" />
      <span className="visually-hidden">{t('common.loading')}</span>
    </Container>
  );
};
